import { render, staticRenderFns } from "./Post.vue?vue&type=template&id=281c3b37&scoped=true"
import script from "./Post.vue?vue&type=script&lang=js"
export * from "./Post.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281c3b37",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('281c3b37')) {
      api.createRecord('281c3b37', component.options)
    } else {
      api.reload('281c3b37', component.options)
    }
    module.hot.accept("./Post.vue?vue&type=template&id=281c3b37&scoped=true", function () {
      api.rerender('281c3b37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/preview/Post.vue"
export default component.exports